import { Component, ComponentFactoryResolver, Injector, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Action, CrudEditorParentService, CrudEditorSelfService, CrudRowsEditComponent, FormStorage, HateoasMultipleResponseObject, UserStorage } from "@scisys-uim/uim-common";
import { AMMUNITION_STOCK_TYPE, AmmunitionStockEvent, AmmunitionStockEventType, ASSET_MAINTENANCE_TYPE, CostCentre } from "assets-model";
import { Observable, of } from "rxjs";
import { AmmunitionStockEventRowsComponent } from "./ammunition-stock-event-rows.component";

@Component({
  selector: 'app-ammunition-stock-event-rows-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-rows-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-rows-edit.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AmmunitionStockEventRowsEditorComponent extends CrudRowsEditComponent<AmmunitionStockEvent, number, any> implements OnInit {

  _eventTypeSet: boolean = false;
  get eventType(): AmmunitionStockEventType {
    if (this.context) {
      return this.context?.eventType;
    }
  }

  get ammunitionStockStocktakeComponent(): AmmunitionStockEventRowsComponent {
    return <AmmunitionStockEventRowsComponent>this.rowsItemComponent;
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.setRowsComponentEventType();

    if (this.eventType == 'Stocktake') {
      this.editorTitle = "Ammunition Stocktake";
    } else if (this.eventType == 'Issue') {
      this.editorTitle = "Issue Ammunition to Ranger";
    } else if (this.eventType == 'Addition') {
      this.editorTitle = "Add Ammunition to Stock";
    } else if (this.eventType == 'Return') {
      this.editorTitle = "Return issued Ammunition to Stock ";
    } else {
      this.editorTitle = "Ammunition Stock Event (debug title)";
    }

    this.actions = [];
    const self = this;
    this.actions.push(<Action>{
      get title() {
        return 'Add All Ammunition'
      },
      get enabled() {
        return self.isAddEnabled();
      },
      color: "primary",
      get available() {
        return self.allowsAddAllAmmunition();
      },
      doAction() {
        self.addAllAmmunition();
      }
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.setRowsComponentEventType();
  }

  ngAfterContentChecked(): void {
    if (!this._eventTypeSet) { //late call in case it was never set
      this.setRowsComponentEventType();
    }
  }

  setRowsComponentEventType() {
    if (this.ammunitionStockStocktakeComponent) {
      this.ammunitionStockStocktakeComponent.eventType = this.eventType;
      this._eventTypeSet = true;
    }
  }

  unsavedChanges() {
    return this.ammunitionStockStocktakeComponent?.unsavedChanges();
  }

  retrieveRows(key: CostCentre): Observable<HateoasMultipleResponseObject<AmmunitionStockEvent>> {
    if (this.ammunitionStockStocktakeComponent) {
      return this.ammunitionStockStocktakeComponent.retrieveRows(key);
    } else {
      return of({ items: [] });
    }
  }

  postSave(data: HateoasMultipleResponseObject<AmmunitionStockEvent>): void {
    this.setRows([]); //avoids unsaved changes warnings
    this.rowsItemComponent.setDefaultDisabledFields();
    this.postDefaultsChangesOnSetRows = false;
    this.navigate(this.backRoute(), {
      queryParams: this.backRouteQueryParams(),
    })
  }

  allowsAddAllAmmunition() {
    return this.ammunitionStockStocktakeComponent?.allowsAddAllAmmunition();
  }

  addAllAmmunition() {
    this.ammunitionStockStocktakeComponent?.addAllAmmunition();
  }

  isAddEnabled() {
    return this.ammunitionStockStocktakeComponent?.isAddEnabled();
  }

  allowsView() {
    return false;
  }

  allowsSaveRows() {
    return true;
  }

  backRouteFallback(): any[] {
    return [...AMMUNITION_STOCK_TYPE.searchRouteBase];
  }
}
